import React, { useState, useEffect } from 'react';

import { TemplatePreview } from '@confluence/template-preview';
import { useEditorWidthObserver } from '@confluence/editor-features';

import {
	BlankPageQuickActionsTemplatePreviewContainer,
	BlankPageQuickActionsTemplatePreviewWrapper,
} from './bpqaStyled';
import { useBlankPageQuickActionsContext } from './BlankPageQuickActionsContext';

type BlankPageQuickActionsTemplatePreviewProps = {
	spaceKey: string;
};

export const BlankPageQuickActionsTemplatePreview = ({
	spaceKey,
}: BlankPageQuickActionsTemplatePreviewProps): React.JSX.Element | null => {
	const [previewHovered, setPreviewHovered] = useState<boolean>(false);
	const { templates, templateIndex, buttonHovered } = useBlankPageQuickActionsContext();

	const shouldShowTemplatePreview = buttonHovered || previewHovered;

	const { width } = useEditorWidthObserver({});

	useEffect(() => {
		// we need to preload the TemplatePreview
		// component or the rendering will flicker between
		// skeleton & loaded states
		void TemplatePreview.preload();
	}, []);

	return shouldShowTemplatePreview ? (
		<BlankPageQuickActionsTemplatePreviewWrapper>
			<BlankPageQuickActionsTemplatePreviewContainer
				editorWidth={width}
				shouldShowTemplatePreview={shouldShowTemplatePreview}
				onMouseEnter={() => {
					setPreviewHovered(true);
				}}
				onMouseLeave={() => {
					setPreviewHovered(false);
				}}
				data-testid="bpqa-full-size-template-preview-container"
			>
				<TemplatePreview
					spaceKey={spaceKey}
					templates={templates}
					currentTemplateIndex={templateIndex}
					numPreviewsToFetchAtOnce={3}
				/>
			</BlankPageQuickActionsTemplatePreviewContainer>
		</BlankPageQuickActionsTemplatePreviewWrapper>
	) : null;
};
